module.exports = __webpack_public_path__ + "img/region_northwest.00cb2cf3.svg";